import { useState } from "react";
import { toast } from "sonner";
import { ArrowLeftRight, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useDevAuth } from "@/context/DevAuthContext";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";

// One login, two spaces: developer sandbox ⇄ mini-site client (opened on first use), each billed separately.
export const RoleSwitch = () => {
  const { t } = useI18n();
  const { dev, refresh } = useDevAuth();
  const [busy, setBusy] = useState(false);
  const target = dev.kind === "minisite" ? "developer" : "minisite";
  const has = (dev.roles || []).includes(target);
  const go = async () => {
    setBusy(true);
    try {
      await api.post("/dev/auth/switch", { kind: target });
      await refresh();
      window.scrollTo(0, 0);
    } catch (err) {
      toast.error(translateError(err, t));
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={go} disabled={busy} className="btn-red btn-sm btn-cta max-w-full whitespace-normal text-start" data-testid="role-switch-btn">
      {busy ? <Loader2 className="h-4 w-4 shrink-0 animate-spin" /> : <ArrowLeftRight className="h-4 w-4 shrink-0" />} {t(`role.${has ? "switch" : "open"}.${target}`)}
    </button>
  );
};
